import { useQuery } from '@tanstack/react-query'

import { findCommitments } from '@/features/bidding/endpoints/bids'
import { useErrorHandler } from '@/features/bidding/hooks/useErrorHandler'
import type { MarketDate } from '@/features/bidding/utils/date/marketDate'

const GET_COMMITMENTS_ID = 'GET_COMMITMENTS'

export function useCommitments(date: MarketDate, portfolioCode: string, enabled = true) {
  const { data = null, ...queryResult } = useQuery({
    queryKey: [GET_COMMITMENTS_ID, date, portfolioCode],
    queryFn: () => findCommitments(date, portfolioCode),
    enabled,
  })

  useErrorHandler(queryResult.isError)

  return { allocatedVolumes: data, ...queryResult }
}
